<template>
  <div class="form-input">
    <input
      type="text"
      class="input"
      @input="changeInput"
      :placeholder="placeholder"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SearcherComponent",
  props: {
    placeholder: {
      type: String,
      default: "Buscar...",
    },
  },
  setup(props, context) {
    function changeInput(event: any) {
      context.emit("update:search", event.target.value);
    }
    return { changeInput };
  },
});
</script>

<style scoped lang="scss">
@import "src/styles/commons/controls/searcherStyle";
</style>
